const customComponentTypes = {

    button: 'button',

    icon: 'icon',

    image: 'image',

    accordion: 'accordion',

    typography: 'typography', 

    content: 'content',

    popover: 'popover',

    spacer: 'spacer',

    divider: 'divider',

    card: 'card',

    genericCard: 'genericCard',

    content2: 'content2',

    feature1: 'feature1',

    image1: 'image1',

    icon1: 'icon1',

    typography1: 'typography1',
    
    tab: 'tab',

    content3: 'content3',

    list: 'list',

    customProgramListing: 'customProgramListing',

    programs : {
        type1 : 'customProgramListing2',
    },

    categories :{
        type1 : 'customCategoryListing1',
        type2 : 'customCategoryListing2',
    },

    form: 'form',

    textField: 'textField',

    articles: 'articles',

    testimonials: {
        type1: 'testimonials1',
        type2: 'testimonials4'
    },

    html: 'html',

    logo: 'logo'

};

export {
    customComponentTypes
}